import BaseEntity from './BaseEntity';
export default class ToolIssue extends BaseEntity {
    constructor(data) {
        super();
        this.fileNames = this.parseProperty(data, 'fileNames');
        this.name = this.parseProperty(data, 'name');
    }
}
